var React = require('react');

function IconLock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M34 20H7v-6a12 12 0 0123.8-2.4 1 1 0 002-.4A14 14 0 005 14v6c-.1 0-5-.5-5 4v24a4 4 0 004 4h30a4 4 0 004-4V24a4 4 0 00-4-4zm2 28a2 2 0 01-2 2H4a2 2 0 01-2-2V24a2 2 0 012-2h30a2 2 0 012 2z","key":0}),React.createElement("path",{"d":"M19 28a5 5 0 00-1 9.9 1 1 0 000 .1v5.9a1 1 0 002 0V38a1 1 0 000-.1 5 5 0 00-1-9.9zm0 8a3 3 0 113-3 3 3 0 01-3 3z","key":1})]);
}

IconLock.defaultProps = {"viewBox":"0 -1 38 54","fill":"currentColor"};

module.exports = IconLock;

IconLock.default = IconLock;
